/*
 * https://github.com/morethanwords/tweb
 * Copyright (C) 2019-2021 Eduard Kuzmenko
 * https://github.com/morethanwords/tweb/blob/master/LICENSE
 */

// Legacy Safari; global `DocumentTouch` is not in every TS `lib` set.
type DocumentTouchConstructor = abstract new () => object;

const g = globalThis as typeof globalThis & {
  DocumentTouch?: DocumentTouchConstructor;
};
const IS_TOUCH_SUPPORTED =
  typeof g.document !== 'undefined' &&
  (('ontouchstart' in g) ||
    // @ts-ignore legacy Safari
    (g.DocumentTouch && g.document instanceof g.DocumentTouch))/*  || true */;

export default IS_TOUCH_SUPPORTED;
